import { createContext } from '@lit/context';
import { LogLevel } from '../shared/types/utils.model';

export type Logger = {
  level: LogLevel;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  stateChange?: (
    previousState: Record<string, unknown>,
    change: Record<string, unknown>,
    nextState: Record<string, unknown>
  ) => void;
};

export const loggerContext = createContext<Logger>(Symbol('logger'));
